const config = {
  defaults: {
    namespace: "Application",
    api_url:
      process.env.REACT_APP_API_URL || "https://dev-api-v3.aplustesting.org",
    api_key:
      process.env.REACT_APP_API_KEY || "d2e621a6646a4211768cd68e26f21228a81",
    clever_client_id:
      process.env.REACT_APP_CLEVER_CLIENT_ID || "a9994e50b199c4ae4c7a",
    redirect_url:
      process.env.REACT_APP_CLEVER_REDIRECT_URL ||
      "https://dev-api-v3.aplustesting.org",
    s3BucketURL:
      process.env.REACT_APP_S3_BUCKET_URL ||
      "https://dev-teacher-v3.aplustesting.org",
    classlink_redirect_url:
      process.env.REACT_APP_CLASSLINK_REDIRECT_URL ||
      "https://api.aplustesting.org",
    classlink_client_id:
      process.env.REACT_APP_CLASSLINK_CLIENT_ID ||
      "c1753904171406caee0bbdbd142339b8203a102c6e94",
  },
};

export default config;
